import React from 'react';
import { usePrefixCls } from '../hooks/usePrefixCls';
var hyphenateRE = /\B([A-Z])/g;

function withWrapper(type, Component) {
  function Icon(props) {
    var _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$fill = props.fill,
        outStrokeColor = _props$fill === void 0 ? '#000' : _props$fill,
        className = props.className,
        style = props.style;
    var classNameArr = ["".concat(usePrefixCls('icon')), "".concat(usePrefixCls('icon-' + type.replace(hyphenateRE, '-$1').toLowerCase()))];

    if (className) {
      classNameArr.push(className);
    }

    return React.createElement("span", {
      className: classNameArr.join(' '),
      style: style
    }, React.createElement(Component, {
      size: size,
      fill: outStrokeColor
    }));
  }

  return Icon;
}

export default withWrapper;